/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackageFieldsSchemaDto } from '../../models/work-package-fields-schema-dto';

export interface UpdateCurrentWorkPackageFieldsSchema$Params {
  id: string;
}

export function updateCurrentWorkPackageFieldsSchema(http: HttpClient, rootUrl: string, params: UpdateCurrentWorkPackageFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageFieldsSchemaDto>> {
  const rb = new RequestBuilder(rootUrl, updateCurrentWorkPackageFieldsSchema.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageFieldsSchemaDto>;
    })
  );
}

updateCurrentWorkPackageFieldsSchema.PATH = '/v0/WorkPackageFieldsSchema/{id}/current';
